import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStreetsReducer from './streets.reducer'
import { AppState } from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromStreetsReducer.streetsesFeatureKey]);

export const selectAllStreets = createSelector(currentState, fromStreetsReducer.selectAll);

export const selectTotalStreets = createSelector(currentState, fromStreetsReducer.selectTotal);

export const selectModifiedStreets = createSelector(selectAllStreets, (streets) => {
  return streets.map((street) => {
    return {
      ...streets
    };
  });
});
